export default __webpack_public_path__ + "static/media/userimage.8bc0abd2.png";